import React from "react";
import { useTranslation } from "react-i18next";
import LegalPage, { Section } from "./LegalPage";

export default function Terms() {
  const { t } = useTranslation("legal");
  return (
    <LegalPage title={t("terms.title")} updated="24 July 2026">
      <p className="text-lg text-[#4B4642]">
        {t("terms.intro")}
      </p>

      <Section heading={t("terms.s1.heading")}>
        <p>{t("terms.s1.body")}</p>
      </Section>

      <Section heading={t("terms.s2.heading")}>
        <p>{t("terms.s2.body")}</p>
      </Section>

      <Section heading={t("terms.s3.heading")}>
        <p>{t("terms.s3.body")}</p>
      </Section>

      <Section heading={t("terms.s4.heading")}>
        <p>{t("terms.s4.body")}</p>
      </Section>

      <Section heading={t("terms.s5.heading")}>
        <p>
          {t("terms.s5.bodyPre")}
          <a href="https://status.orkaiflow.com" className="text-[#E07A5F] font-semibold hover:underline">status.orkaiflow.com</a>
          {t("terms.s5.bodyPost")}
        </p>
      </Section>

      <Section heading={t("terms.s6.heading")}>
        <p>{t("terms.s6.body")}</p>
      </Section>

      <Section heading={t("terms.s7.heading")}>
        <p>
          {t("terms.s7.bodyPre")}
          <a href="mailto:legal@orkaiflow.com" className="text-[#E07A5F] font-semibold hover:underline">legal@orkaiflow.com</a>
          {t("terms.s7.bodyPost")}
        </p>
      </Section>

      <p className="text-xs text-[#7A7571] italic pt-4">
        {t("shell.starterDisclaimer")}
      </p>
    </LegalPage>
  );
}
